var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-divider',{staticClass:"primary mt-5 mb-5"})
}
var staticRenderFns = []

export { render, staticRenderFns }